import api from '../../plugins/api';

const vehicleValuation = (bankUniqueId) => {
  return api.post('/api/bank/callback/vehicle-valuation?sourceId=', { bankUniqueId });
};

export default vehicleValuation;
